import { ProductSelectV2 } from '@frontend/product/select';
import { updateField } from '@frontend/repository';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

import useProductConstraintDataInput from './product-constraint-data-input.controller';

const ID = 'product-constraint-data-input';
export interface ProductConstraintDataInputProps {
    dispatch: ThunkDispatch<any, any, Action>;
    formId: string;
    id?: string;
    label?: string;
    className?: string;
    required?: boolean;
}

const ProductConstraintDataInput = (props: ProductConstraintDataInputProps) => {
    const viewProps = useProductConstraintDataInput(props);

    return (
        <div
            id={ID}
            className='flex w-full flex-row'>
            <ProductSelectV2
                required
                value={viewProps.formValues?.product_id ?? undefined}
                onChange={(v) => {
                    props.dispatch(updateField({ formId: props.formId, key: 'data', value: v ? { product_id: v } : undefined }));
                }}
            />
        </div>
    );
};

export default ProductConstraintDataInput;
